import { Badge } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledBadge = styled(Badge, {
  shouldForwardProp: (prop) => prop !== 'status',
})<{ status: string }>(({ status, theme }) => {
  const color =
    status === 'AVAILABLE'
      ? theme.palette.success.main
      : status === 'AWAY'
        ? theme.palette.warning.main //theme.YELLOW
        : theme.palette.grey[500] //theme.GREY
  return {
    '& .MuiBadge-badge': {
      backgroundColor: color,
      color: color,
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        content: '""',
      },
    },
  }
})

export const ImageStyled = styled('img')({
  borderRadius: '50%',
  objectFit: 'cover',
})
